import scrollToElement from 'scroll-to-element'
import { startsWith, split } from 'lodash/fp'

interface ScrollToElementOptions {
  offset: number
}

export default function scroll(
  domId: string,
  options?: ScrollToElementOptions,
) {
  if (startsWith('.', domId)) {
    scrollToElement(domId, { duration: 1000, ...options })
  } else {
    scrollToElement(
      `${startsWith('#', domId) ? '' : '#'}${split('?', domId)[0]}`,
      { duration: 1000, ...options },
    )
  }
}
